import { OktonLoadingCard, OktonErrorCard } from '@okton/platform-ui';
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface PainelProps {
  titulo: string;
  // O que fica à direita do título: um link, um seletor.
  acao?: React.ReactNode;
  isLoading?: boolean;
  isError?: boolean;
  error?: unknown;
  onRetry?: () => void;
  // Altura enquanto carrega ou falha, para o grid não pular quando o dado
  // chega.
  h?: string;
  children?: React.ReactNode;
}

/**
 * Moldura dos painéis que não são gráfico (tabelas e pendências), a mesma
 * das tabelas do Analytics - "Transações do Dia" em TotalPaid, por exemplo.
 * Os gráficos usam o próprio Chart, que já traz a moldura dele.
 */
const Painel: React.FC<PainelProps> = ({
  titulo,
  acao,
  isLoading,
  isError,
  error,
  onRetry,
  h = '300px',
  children,
}) => {
  const bg = useColorModeValue('white', 'gray.800');

  if (isLoading) return <OktonLoadingCard h={h} title={titulo} />;
  if (isError)
    return (
      <OktonErrorCard
        h={h}
        description={
          error instanceof Error && error.message
            ? error.message
            : 'Tente novamente. Se o problema persistir, contate o suporte.'
        }
        onRetry={onRetry}
      />
    );

  return (
    <Flex
      rounded="2xl"
      p="4"
      bg={bg}
      borderWidth="1px"
      w="100%"
      h="100%"
      flexDir="column"
      minW="0"
    >
      <Flex justify="space-between" align="center" mb="2" minH="8">
        <Text>{titulo}</Text>
        {acao}
      </Flex>
      <Box flex="1" minW="0">
        {children}
      </Box>
    </Flex>
  );
};

export default Painel;
